import { Component, OnInit, ViewChild, AfterViewInit, ElementRef , HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { tap, catchError, finalize, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of, fromEvent } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { projectConstants } from '../../../shared/constants/project-constants';
import { PaginationService } from 'src/app/services/pagination.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { ChangeStatusComponent } from '../change-status/change-status.component';
import { UserService } from 'src/app/services/user.service';
import { MatPaginator } from '@angular/material/paginator';
@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit, AfterViewInit {
  dataSource = new UserDataSource(this.userService);
  tableFilters = '';
  displayedColumns = [ 'id', 'firstName', 'lastName', 'email', 'mobileNo', 'userStatus', 'userType' , 'createdDate'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  selectedRowIndex = -1;
  showToolBar = false;
  collapsed;
  collapsedlcFilter;
  userCount: any;
  scConfig: any = {};
  userTypes: any = [];
  screenHeight;
  screenWidth;
  showsaleschannel;
  small_device_display = false;
  salesfilter;
  accountTypes: any = [];
  salesChannelfilter;
  consumerCount: number;
  user: any;
  type: any;
  sales_type_statuses = projectConstants.SALES_TYPE_STATUSES;
  constructor(
    private pagination: PaginationService,
    private userService: UserService,
    private commonFilter: CommonfilterService,
    private route: ActivatedRoute,
    private router: Router,
    private commonfilterService: CommonfilterService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog ) {
      this.commonfilterService.getConfigData()
      .subscribe(res => {
        this.scConfig = res;
        this.userTypes = this.scConfig.userType;
      });
      this.onResize();
    }

  ngOnInit() {
    this.dataSource.loadUser(this.tableFilters, 'false', 0, 100);
    this.getTotalCountByFilters(this.tableFilters);
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  getTotalCountByFilters(filters) {
    this.userService.getTotalFilterCount(filters)
      .subscribe(res => {
        this.userCount = res;
        // this.paginator.pageIndex = 0;
      });
  }
  ngAfterViewInit() {
    this.paginator.page
    .pipe(
        tap(() => this.loadUserPage())
    )
    .subscribe();

    fromEvent(this.go.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.tableFilters = this.commonFilter.createfilterParams('user');
            this.getTotalCountByFilters(this.tableFilters);
            this.paginator.pageIndex = 0;
            this.loadUserPage();


        })
    )
    .subscribe();
  }
  loadUserPage() {
    // const count = 10;
    const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
    this.dataSource.loadUser(
      this.tableFilters, 'false', count,
      this.paginator.pageSize
   );

  }
  createuser() {
    this.router.navigate(['../createuser'],  { queryParams: {'type' : 'add'} , relativeTo: this.activatedRoute});
    this.getTotalCountByFilters(this.tableFilters);
    this.loadUserPage();
   }
   updateuser() {
    // tslint:disable-next-line: max-line-length
    this.router.navigate(['../createuser'], { queryParams: {'type' : 'edit', special: JSON.stringify(this.user)} , relativeTo: this.activatedRoute});
    this.getTotalCountByFilters(this.tableFilters);
    this.loadUserPage();
    this.showToolBar = false;
   }
   changeStatus() {

    const dialogRef = this.dialog.open(ChangeStatusComponent, {
      width: '600px',
      data: { 'user': this.user }
    });
    dialogRef.afterClosed().subscribe(result => {
      const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
      this.selectedRowIndex = -1;
      this.loadUserPage();
      this.showToolBar = false;
    });
  }
  onRowClicked(user) {
    this.selectedRowIndex = user.user.id;
    this.user = user;
    this.showToolBar = true;
  }
}
export class UserDataSource implements DataSource<any> {

  constructor(private userService: UserService) {

  }
  public loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  private salesChannelSubject = new BehaviorSubject<any>([]);

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.salesChannelSubject.asObservable();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.salesChannelSubject.complete();
    this.loadingSubject.complete();
  }
  loadUser(filter,
    sortDirection, tcount, pageSize) {
    this.loadingSubject.next(true);

    this.userService.getUsers(filter, sortDirection,
      tcount, pageSize).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(
        salesChannels => {
          this.salesChannelSubject.next(salesChannels);
        }
      );
  }
}
